<template>
   <div>
     <component
       class="MediaGridItemImage"
       :is="tagType"
       :to="data.route || false"
       :href="data.link || false"
     >
         <image-component
         v-bind="data.image"
         :zoom="!!data.route || !!data.link" />

     </component>

     <media-grid-item-title
         v-if="data.title"
         :data="data" />

     <media-grid-item-description
       v-if="data.description"
       :data="data" />

   </div>
 </template>

<script>
export default {
  name: 'MediaGridItemImage',

  props: {
    data: {
      type: Object,
      required: true
    }
  },

  computed: {
    tagType () {
      if (this.data.route) return 'router-link'

      if (this.data.link) return 'a'

      return 'div'
    }
  }
}
</script>

<style>
.MediaGridItemImage {
}
</style>



// WEBPACK FOOTER //
// MediaGridItemImage.vue?2b5ae5f4